export default __webpack_public_path__ + "static/media/logo-old.92a6a880.jpg";